"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
exports.translateStringToDate = function (dateString) {
    if (!dateString)
        return null;
    return new Date(dateString);
};
exports.MONTHS = {
    0: 'Janeiro',
    1: 'Fevereiro',
    2: 'Março',
    3: 'Abril',
    4: 'Maio',
    5: 'Junho',
    6: 'Julho',
    7: 'Agosto',
    8: 'Setembro',
    9: 'Outubro',
    10: 'Novembro',
    11: 'Dezembro',
};
exports.elapsedCreationTime = function (createdAt) {
    var current = moment_1.default();
    var date = moment_1.default(createdAt);
    return {
        minutes: current.diff(date, 'minutes'),
        hours: current.diff(date, 'hours'),
        days: current.diff(date, 'days'),
    };
};
exports.timeSinceCreation = function (createdAt) {
    var _a = exports.elapsedCreationTime(createdAt), minutes = _a.minutes, hours = _a.hours, days = _a.days;
    if (days > 2) {
        var date = new Date(createdAt);
        return date.getDate() + " de " + exports.MONTHS[date.getMonth()] + " de " + date.getFullYear();
    }
    if (days > 0 && days <= 2) {
        var str_1 = "h\u00E1 " + days + " dia";
        return days === 1 ? str_1 : str_1 + 's';
    }
    if (hours > 0 && hours < 24) {
        var str_2 = "h\u00E1 " + hours + " hora";
        return hours === 1 ? str_2 : str_2 + 's';
    }
    if (minutes === 0)
        return 'agora';
    var str = "h\u00E1 " + minutes + " minuto";
    return minutes === 1 ? str : str + 's';
};
